var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgElectron = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 256 256",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 128,
  cy: 128,
  r: 128,
  fill: "#2b2e3a"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#9feaf9",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M101 72q-42-7-55 14-9 17 4 40a3 3 0 1 0 5-3q-12-21-5-34 12-18 50-12a3 3 0 0 0 1-5m-37 72q16 18 39 31c38 22 78 28 98 14a3 3 0 1 0-3-4c-18 12-56 7-92-14q-23-13-39-31a3 3 0 1 0-3 4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M195 141c17-20 23-41 14-55q-9-15-35-16a3 3 0 0 0 0 5q23 1 31 14 9 19-14 48a3 3 0 1 0 4 4m-44-68q-24 5-48 18c-39 23-64 56-60 80a3 3 0 1 0 5-1c-3-21 21-52 58-74q23-13 46-18a3 3 0 1 0-1-5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M88 188q14 39 40 40 19 0 31-23a3 3 0 1 0-4-2q-13 20-27 20-22-1-35-37a3 3 0 1 0-5 2m81-5q7-23 7-50c0-44-15-82-37-92a3 3 0 0 0-2 5c19 9 34 45 34 87q0 27-7 48a3 3 0 1 0 5 2m50-3a13 13 0 1 0-25 0 13 13 0 0 0 25 0m-5 0a7 7 0 1 1-15 0 7 7 0 0 1 15 0M48 193a13 13 0 1 0 0-25 13 13 0 0 0 0 25m0-5a7 7 0 1 1 0-15 7 7 0 0 1 0 15"
}), /*#__PURE__*/React.createElement("path", {
  d: "M128 54a13 13 0 1 0 0-25 13 13 0 0 0 0 25m0-5a7 7 0 1 1 0-15 7 7 0 0 1 0 15m2 93q-9 2-11-7a9 9 0 0 1 7-11 9 9 0 0 1 4 18"
})))));
export default SvgElectron;